import type { Client } from "@opensea/graphql"
import type { Address } from "@opensea/utils"
import { prefetchProfileItems } from "@/components/items/profile/ProfileItemsList"
import { prefetchProfilePageLayout } from "../../layout-query"

export function prefetchProfileItemsPage(address: Address, client: Client) {
  prefetchProfileItems(address, client)
  prefetchProfilePageLayout(address, client)
}
